<div class="container">
    <div class="row justify-content-center">
        <div>
            <app-quick-link [ngClass]="{'is-popin': false, 'is-view mat-elevation-z4': true}">
            </app-quick-link>
        </div>
    </div>
</div>
